module.exports = __webpack_public_path__ + "media/images/products/demo/monitor-ef3bf94cbd2085eb779c7d4b62c80935.png";